/* GRL Society: initialize asynchronously injected product recommendation sliders.
   The recommendation markup is fetched after page load, so the theme's normal
   in-view slider initialization can be missed. This keeps the native slider,
   buttons, scrolling, and status behavior intact. */

(() => {
  const initRecommendationSlider = (container) => {
    const slider = container.querySelector('slider-element');

    if (
      !slider ||
      slider.dataset.grlRecommendationsInitialized === 'true'
    ) {
      return;
    }

    slider.dataset.grlRecommendationsInitialized = 'true';

    // Refresh the item cache now that the recommendation cards exist.
    if (typeof slider.reset === 'function') {
      slider.reset();
    }

    // Initialize the theme's native slider listeners/status handling.
    if (typeof slider.init === 'function') {
      slider.init();
    }
  };

  document.addEventListener(
    'recommendations:loaded',
    (event) => {
      const container = event.target;

      if (
        !(container instanceof Element) ||
        !container.matches('product-recommendations')
      ) {
        return;
      }

      // Allow the injected DOM to finish connecting
      // before measuring card widths.
      requestAnimationFrame(() => {
        initRecommendationSlider(container);
      });
    }
  );

  // Theme editor / cached markup safety:
  // initialize any already-rendered instance.
  document
    .querySelectorAll('product-recommendations')
    .forEach((container) => {
      if (
        container.querySelector('slider-element')
      ) {
        requestAnimationFrame(() => {
          initRecommendationSlider(container);
        });
      }
    });
})();